// extracted by mini-css-extract-plugin
export default {"map_info_container":"MapInfo_map_info_container__TyBZw","attribution":"MapInfo_attribution__wn0P1","attribution_link":"MapInfo_attribution_link__gMNV4"};